import { COLOR } from "@finway-group/shared/lib/consts/colors"
import { Button, PageHeader, Space, Tooltip } from "antd"
import { OptionButtons } from "Components/OptionButtons"
import React from "react"
import { ArrowLeftCircle, ArrowRightCircle, Edit2 as EditIcon, MoreHorizontal as MoreIcon } from "react-feather"
import { useTranslation } from "react-i18next"
import { getTooltipPopupContainer } from "Shared/utils/helper.utils"
import { DeliveryNote } from "../types/deliveryNote.interfaces"

interface DeliveryNoteDetailsHeaderProps {
    title: React.ReactNode
    deliveryNote: DeliveryNote
    editable: boolean
    onBack: () => void
    onEdit?: () => void
    onDelete?: () => void
    onPrev?: () => void
    onNext?: () => void
}

export const DeliveryNoteDetailsHeader = ({ title, deliveryNote, editable, onBack, onEdit, onDelete, onPrev, onNext }: DeliveryNoteDetailsHeaderProps) => {
    const { t } = useTranslation()
    const buttons = (
        <Space>
            <Tooltip getPopupContainer={getTooltipPopupContainer} placement="bottomLeft">
                <Button className="m-5 btn-default" disabled={!editable || !onEdit} onClick={editable ? onEdit : undefined}>
                    <EditIcon />
                    <span>{t("action:edit")}</span>
                </Button>
            </Tooltip>
            <OptionButtons record={deliveryNote} onDelete={editable ? onDelete : undefined} isEditDisabled={!editable} isDeleteDisabled={!editable}>
                <Button onClick={(e) => e.stopPropagation()} className="m-5 btn-default">
                    <MoreIcon />
                </Button>
            </OptionButtons>
            <Button onClick={onPrev} disabled={!onPrev} className="m-5 btn-default">
                <ArrowLeftCircle color={!onPrev ? COLOR.button.disabled : undefined} />
            </Button>
            <Button onClick={onNext} disabled={!onNext} className="m-5 btn-default">
                <ArrowRightCircle color={!onNext ? COLOR.button.disabled : undefined} />
            </Button>
        </Space>
    )

    return <PageHeader title={title} extra={buttons} onBack={onBack} />
}
